import type { RawCartAddress } from "../../../../../../types/api/wcStoreApi/wcStoreApiCartEndpointsTypes";
import type { TransformedAddress } from "../../../types/cartApiTypes";

/**
 * A pure helper function to transform a raw address object to camelCase.
 * Accepts optional extra fields to merge into the result (e.g., TCKN/VKN).
 *
 * @param addr The raw address object from the WC Store API.
 * @param extraFields Optional object containing extra fields like tckn, vkn, customerType.
 * @returns A transformed address object.
 */
export const transformAddress = (
  addr: RawCartAddress,
  extraFields?: Partial<TransformedAddress>
): TransformedAddress => ({
  firstName: addr.first_name,
  lastName: addr.last_name,
  company: addr.company,
  address1: addr.address_1,
  address2: addr.address_2,
  city: addr.city,
  state: addr.state,
  postcode: addr.postcode,
  country: addr.country,
  email: addr.email,
  phone: addr.phone,
  // Merge extra fields if provided
  ...extraFields,
});
